import { Breakpoints, Container, ContainerPadding, CTA } from '@volkswagen-onehub/components-core';
import { Close } from '@volkswagen-onehub/icons-core';
import { FocusLayerSizeV2, ShimBackgroundTypeV2 } from '@volkswagen-onehub/layer-manager';
import React from 'react';
import { PortalContext } from '../../../../context/PortalContext';
import { BonusPopup } from './bonus-popup';
import { Bonus } from '@esportal/portal-service';
import { GetPersonUser } from '@esportal/portal-service';
import { useTrackingManager } from '../../../../tracking/useTrackingManager';
import { BonusvwBank } from './bonus-vwbank';

export const BonusPopupLayer: React.FC<{
	className: string;
	bonusPopupData: Bonus | undefined;
	isBonusPopupVisible: boolean;
	setIsBonusPopupVisible: React.Dispatch<React.SetStateAction<boolean>>;
	bonusLayerRef: React.RefObject<HTMLElement>;
	userData: GetPersonUser | null;
}> = ({ bonusPopupData, setIsBonusPopupVisible, isBonusPopupVisible, bonusLayerRef, userData }) => {
	const { layerManager } = React.useContext(PortalContext);
	const portalContext = React.useContext(PortalContext);
	const trackingManager = useTrackingManager();
	const [vwBankLayerRef, setvwBankLayerRef] = React.useState<any>(null);

	const handleClose = () => {
		setIsBonusPopupVisible(false);
		if (bonusPopupData) {
			trackingManager.trackClubVWLayerCloseClick(`Bonus Popup Layer: ${bonusPopupData.title}`, {
				contentId: `Bonus Popup Layer: ${bonusPopupData.title}`,
			});
		}

		if (bonusLayerRef?.current) {
			(bonusLayerRef?.current as HTMLDialogElement).close();
			return ((bonusLayerRef.current as any) = null);
		}
		return null;
	};

	const closevwBankLayer = () => {
		trackingManager.trackClubVWLayerCloseClick('VWFS exit Layer', {
			contentId: 'VWFS exit Layer',
		});
		if (vwBankLayerRef) {
			vwBankLayerRef.close();
			setvwBankLayerRef(null);
		}
	};

	const vwBankLayer = () => {
		const layer = layerManager.openContentLayerV2(
			() => {
				return userData && bonusPopupData?.cta.bonusPageId ? (
					<BonusvwBank userData={userData} vwBankUrl={bonusPopupData?.cta.bonusPageId} />
				) : (
					<></>
				);
			},
			{},
			{
				shimBackgroundType: ShimBackgroundTypeV2.OPAQUE,
				closeButtonLabel: '',
				contentHeadline: '',
				onClose: closevwBankLayer,
			},
		);
		setvwBankLayerRef(layer);
	};

	const renderBonusPopUpLayer = () => {
		return (
			<PortalContext.Provider value={portalContext}>
				<Container
					horizontalAlign={'flex-end'}
					padding={{
						top: ContainerPadding.dynamic0100,
						right: {
							[Breakpoints.default]: ContainerPadding.grid001,
							[Breakpoints.b1600]: ContainerPadding.dynamic0100,
						},
						bottom: ContainerPadding.dynamic0100,
					}}
				>
					<CTA
						tag="button"
						emphasis="tertiary"
						onClick={handleClose}
						aria-label="Close pop-up"
						icon={<Close variant="default" aria-hidden />}
					/>
				</Container>
				{bonusPopupData && userData && <BonusPopup bonusPopupData={bonusPopupData} vwBankLayer={vwBankLayer} />}
			</PortalContext.Provider>
		);
	};

	React.useEffect(() => {
		let layer: any;
		if (isBonusPopupVisible) {
			layer = layerManager.openFocusLayer(
				renderBonusPopUpLayer,
				{},
				{
					size: FocusLayerSizeV2.A,
					shimBackgroundType: ShimBackgroundTypeV2.OPAQUE,
				},
			);
			(bonusLayerRef.current as any) = layer;
		}
		return () => {
			if (layer) {
				layer.close();
				(bonusLayerRef.current as any) = null;
			}
		};
	}, [isBonusPopupVisible, layerManager, bonusLayerRef, portalContext]);

	return null;
};
